import { Star } from "lucide-react";

export const Stars = ({ value = 0, size = 16, onChange, testid }) => (
  <div className="flex items-center gap-1" data-testid={testid}>
    {[1, 2, 3, 4, 5].map((n) => {
      const filled = n <= Math.round(value);
      const icon = <Star size={size} className={filled ? "text-[#D4AF37] fill-[#D4AF37]" : "text-white/20"} />;
      return onChange ? (
        <button key={n} type="button" onClick={() => onChange(n)} data-testid={`${testid}-${n}`} aria-label={`${n} stars`}
          className="transition-transform hover:scale-110">{icon}</button>
      ) : <span key={n}>{icon}</span>;
    })}
  </div>
);
